import { defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine'
import style from './block.module.scss'
import EditableHeading from '@smartfire/components/editable-heading'
import SmartParallax from '@smartfire/components/smart-parallax'
import React from 'react'
import clsx from 'clsx'

const Inspector = React.lazy(() => import('./Inspector'))

function HautPage({ isParallax, isOverlay, title }) {
    useInspectorControl(Inspector)
    const { isEditing } = useEditor()

    return (
        <SmartParallax
            backgroundImage="image"
            minHeight="340"
            strength={isParallax ? 300 : -1}
            className={clsx(style.parallax, isOverlay && style.overlay)}
        >
            {isEditing ? (
                <EditableHeading smartProp="title" placeholder="Insérez le titre" className={style.title} />
            ) : (
                title.content && (
                    <EditableHeading smartProp="title" placeholder="Insérez le titre" className={style.title} />
                )
            )}
        </SmartParallax>
    )
}

export default defineBlock({
    Block: HautPage,
    smartProps: {
        image: smartProps.image,
        title: smartProps.object.withDefault({
            headingLevel: 1,
            content: '',
        }),
        isParallax: smartProps.bool.withDefault(true),
        isOverlay: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Haut Page',
    },
})
